module.exports = __webpack_public_path__ + "img/badge-platinum.47b67a92.png";